// extracted by mini-css-extract-plugin
export default {"wrapper":"FestivalProSchedule_wrapper__++WOr","heading":"FestivalProSchedule_heading__LnBiA"};